import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isNative, getPlatform } from '@/lib/capacitor';
import { registerPushToken } from '@/api/push';

export function usePushNotifications(enabled: boolean): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled || !isNative()) return;

    let cancelled = false;

    async function setup() {
      try {
        const { PushNotifications } = await import('@capacitor/push-notifications');

        const perm = await PushNotifications.requestPermissions();
        if (perm.receive !== 'granted') return;

        await PushNotifications.register();

        PushNotifications.addListener('registration', async ({ value: token }) => {
          if (cancelled) return;
          const platform = getPlatform() as 'ios' | 'android';
          await registerPushToken(token, platform).catch(console.error);
        });

        PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
          const link = action.notification.data?.link as string | undefined;
          if (link) navigate(link);
        });
      } catch (err) {
        console.error('[push] setup error:', err);
      }
    }

    void setup();
    return () => { cancelled = true; };
  }, [enabled, navigate]);
}
